export type ProfessionalVerificationStatus =
  | "not_submitted"
  | "pending"
  | "verified"
  | "rejected";

export type ProfessionalVerificationMethod =
  | "none"
  | "automatic"
  | "manual_review"
  | "manual_approved"
  | "manual_rejected";

export type ProfessionalVerificationInfo = {
  status: ProfessionalVerificationStatus;
  crm: string;
  crmState: string;
  rqe: string;
  specialty?: string;
  subspecialty?: string;
  method?: ProfessionalVerificationMethod;
  message?: string;
  officialName?: string;
  officialSpecialties?: string[];
  submittedAt?: unknown;
  verifiedAt?: unknown;
  reviewedAt?: unknown;
};

export const DEFAULT_PROFESSIONAL_VERIFICATION: ProfessionalVerificationInfo = {
  status: "not_submitted",
  crm: "",
  crmState: "",
  rqe: "",
  specialty: "",
  subspecialty: "",
  method: "none",
  message: "",
  officialName: "",
  officialSpecialties: [],
};

export const normalizeProfessionalVerificationStatus = (
  value: unknown
): ProfessionalVerificationStatus => {
  if (value === "pending" || value === "verified" || value === "rejected") {
    return value;
  }

  return "not_submitted";
};

export const normalizeProfessionalVerificationMethod = (
  value: unknown
): ProfessionalVerificationMethod => {
  if (
    value === "automatic" ||
    value === "manual_review" ||
    value === "manual_approved" ||
    value === "manual_rejected"
  ) {
    return value;
  }

  return "none";
};
